module.exports = __webpack_public_path__ + "img/service-repair.8760f5c4.png";